// extracted by mini-css-extract-plugin
export default {"cardContainer":"cardcontainer_cardContainer__EvET6"};